import { NavLogo } from "@certn/cascadia-react/components/navigation/navigation-top/NavLogo";
import {
  brandAssetDisplayUrl,
  useBrandAssetObjectUrls,
} from "../../pages/settings/branding/logo-and-icon/upload/brandAssetObjectUrls";
import { useGetSavedBrandAssetUrls } from "../../pages/settings/branding/logo-and-icon/upload/useSaveBrandAssets";

export function AppLogo() {
  const { data, isLoading } = useGetSavedBrandAssetUrls();
  useBrandAssetObjectUrls();

  if (isLoading) {
    return null;
  }

  return (
    <NavLogo
      logoUrl={brandAssetDisplayUrl(data?.org_logo_url)}
      darkLogoUrl={brandAssetDisplayUrl(data?.org_logo_url_dark_mode)}
      orgIconUrl={brandAssetDisplayUrl(data?.org_icon_url)}
      orgIconUrlDarkMode={brandAssetDisplayUrl(data?.org_icon_url_dark_mode)}
    />
  );
}
